export { default } from './CardContent';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/CardContent/index.js
// module id = 816
// module chunks = 2